import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { User, Lock, Phone, Copy, EyeOff, Eye, Mail } from 'lucide-react'; // Añadí Whatsapp por si lo quieres usar
import { forgotPassword, handleForgotPasswordWithEmailAndPhone, updatePasswordFromLanding, getCustomerIdentifierByCamaraIdentifier, handleUpdateOrCreateUser } from '../api/Login.api';
import { useRevalidator } from 'react-router-dom';
import { getCustomerByCustomerId } from "../../customerDashboard/api/Customer.api";
import axios from 'axios';


interface ForgotPwdModalProps {
    isOpen: boolean;
    onClose: () => void;
}

interface User {
    id?: string;
    name: string;
    surname: string;
    email: string;
    password: string;
    role: string;
    phoneNumber: string;
    identifier: string;
    active: boolean;
    createdAt: Date;
    permissions: string[];
    customerId: string;

}

const ForgotPwdModal: React.FC<ForgotPwdModalProps> = ({ isOpen, onClose }) => {

    const [phoneNumberPartial, setPhoneNumberPartial] = useState("");
    const [identifier, setIdentifier] = useState("");
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [newPassword, setNewPassword] = useState<string | null>(null);
    const [validatePassword, setValidatePassword] = useState<string | null>(null);
    const [isSuccess, setIsSuccess] = useState(false);
    const [userValidated, setUserValidated] = useState<User | null>(null);
    const [showWhatsappError, setShowWhatsappError] = useState(false);
    const [showIDClick, setShowIDClick] = useState(false);
    const [copyStatus, setCopyStatus] = useState<'copy' | 'copied'>('copy');
    const [showPassword, setShowPassword] = useState(false);
    const [showValidatePassword, setShowValidatePassword] = useState(false);
    const [block, setBlock] = useState(false);
    const [showUrlClick, setShowUrlClick] = useState(false);
    const [loginUrl, setLoginUrl] = useState("");
    const [phoneNumberComplete, setPhoneNumberComplete] = useState("");
    const [customerId, setCustomerId] = useState<string | null>(null);
    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [passwordUrl, setPasswordUrl] = useState("");
    const [passwordValidatorUrl, setPasswordValidatorUrl] = useState("");
    const [URLuserValidated, setURLuserValidated] = useState<User | null>(null);
    const [newUserAndPassword, setNewUserAndPassword] = useState(false);
    const [showPasswordGenerated, setShowPasswordGenerated] = useState(false);
    const [userWasValidated, setUserWasValidated] = useState(false);
    const [showUserAndPwdClick, setShowUserAndPwdClick] = useState(false);


    const handleTogglePassword = () => {
        setShowPasswordGenerated(!showPasswordGenerated);
    };

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [onClose]);

    const handleCopy = async () => {
        if (passwordUrl) {
            try {
                await navigator.clipboard.writeText(passwordUrl);
                setCopyStatus('copied');
                toast.info("¡Contraseña copiada al portapapeles!");
                setTimeout(() => {
                    setCopyStatus('copy');
                }, 2000);
            } catch (err) {
                console.error('Error al intentar copiar:', err);
                toast.error("No se pudo copiar la contraseña. Por favor, cópiala manualmente.");
            }
        }
    };


    const handleCopyNewPassword = async () => {
        if (newPassword) {
            try {
                await navigator.clipboard.writeText(newPassword);
                setCopyStatus('copied');
                toast.info("¡Contraseña copiada al portapapeles!");
                setTimeout(() => {
                    setCopyStatus('copy');
                }, 2000);
            } catch (err) {
                console.error('Error al intentar copiar:', err);
                toast.error("No se pudo copiar la contraseña. Por favor, cópiala manualmente.");
            }
        }
    };

    const handleUrl = async () => {
        const urlParts = loginUrl.split("/");
        let customerIdentifier = "";
        let camaraIdentifier = "";

        if (urlParts.includes("customerDashboard")) {
            customerIdentifier = urlParts[urlParts.indexOf("customerDashboard") + 1];
            return { "customer": customerIdentifier };
        } else if (urlParts.includes("dashboard")) {
            camaraIdentifier = urlParts[urlParts.indexOf("dashboard") + 1];
            return { "camara": camaraIdentifier };
        } else {
            toast.error("La URL ingresada no es válida. Por favor, verifica e intenta nuevamente.");
            setLoading(false);
            return;
        }
    }


    const handleBackToOptions = () => {
        setShowIDClick(false);
        setShowUrlClick(false);
        setShowUserAndPwdClick(false);
    };

    // --- Lógica de Validación de Teléfono (Importada) ---
    const validatePhoneNumber = (phone: string): boolean => {
        // Permite un '+' opcional al inicio, seguido de 7 a 15 dígitos.
        const phoneRegex = /^\+?[0-9]{7,15}$/;
        return phoneRegex.test(phone);
    };
    // ----------------------------------------------------



    useEffect(() => {
        console.log("userValidated:", userWasValidated);
    }, [userWasValidated]);

    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        setLoading(true);
        setIsSuccess(false);
        setNewPassword(null);
        setShowWhatsappError(false);

        console.log("showIDClick:", showIDClick);
        console.log("showUrlClick:", showUrlClick);
        console.log("showUserAndPwdClick:", showUserAndPwdClick);

        if (passwordUrl !== passwordValidatorUrl) {
            toast.error("Las contraseñas no coinciden. Por favor, verifica e intenta nuevamente.");
            return;
        }

        const sanitizedEmail = email.toLowerCase().trim();
        let userData: Partial<User> = {};

        //ID LOGIC
        if (showIDClick) {

            // --- VALIDACIÓN DE TELÉFONO PARA URL LOGIC ---
            if (!validatePhoneNumber(phoneNumberComplete)) {
                toast.error("Por favor, ingrese un número de teléfono válido. Debe contener el código de área, solo dígitos, y opcionalmente puede incluir el '+' al inicio. Ejemplo: +5491112345678.");
                setLoading(false);
                return;
            }
            // ---------------------------------------------

            userData = {
                phoneNumber: phoneNumberComplete,
                identifier,
                email: sanitizedEmail
            };
            try {
                const data = await forgotPassword(userData);
                if (data && data.state === "validated") {
                    //setIsSuccess(true);
                    setUserValidated(data.userValidated);
                    setShowIDClick(false);
                    onClose();
                    

                    toast.success("¡Datos validados! Ahora podes acceder con el mail y el ID");
                } else {
                    toast.error("No se pudieron validar tus datos. Por favor, verifica e intenta nuevamente.");
                    setShowWhatsappError(true);
                }

            } catch (error) {
                console.error(error);
                if (axios.isAxiosError(error) && error.response) {
                    const toastId = toast.error(error.response.data.error || "Error desconocido", {
                        autoClose: 10000
                    });
                    setTimeout(() => toast.dismiss(toastId), 20000);
                } else {
                    const err = error as Error;
                    toast.error(err.message || "Error desconocido");
                }
                setIsSuccess(false);
                setShowWhatsappError(true);
            } finally {
                setLoading(false);
            }

            //URL LOGIC
        } else if (showUrlClick) {

            // --- VALIDACIÓN DE TELÉFONO PARA URL LOGIC ---
            if (!validatePhoneNumber(phoneNumberComplete)) {
                toast.error("Por favor, ingrese un número de teléfono válido. Debe contener el código de área, solo dígitos, y opcionalmente puede incluir el '+' al inicio. Ejemplo: +5491112345678.");
                setLoading(false);
                return;
            }
            // ---------------------------------------------


            const identifierToFetch = await handleUrl();

            if (identifierToFetch && "customer" in identifierToFetch) {
                console.log("Es un customer"); //CLIENTE
                const customerIdentifier = identifierToFetch.customer;

                try {
                    const customerData = await getCustomerByCustomerId(customerIdentifier);
                    console.log("customerData obtenido:", customerData);
                    //OBTENGO EL CLIENTE ENTERO
                    if (customerData && customerData.identifier) {


                        userData = {
                            phoneNumber: phoneNumberComplete,
                            identifier: customerData.identifier,//customer
                            email: sanitizedEmail,
                            customerId: customerIdentifier,
                            name,
                            surname,
                            password: passwordUrl,
                            role: "defaultCustomerUser",
                        };


                        try {
                            const data = await handleUpdateOrCreateUser(userData);
                            if (data && data.id) {
                                setNewUserAndPassword(true);
                                setURLuserValidated(data.user);
                                toast.success("¡Datos validados!");
                            } else {
                                toast.error("No se pudieron validar tus datos. Por favor, verifica e intenta nuevamente.");
                                setShowWhatsappError(true);
                            }
                        } catch (error) {
                            console.error(error);
                            if (axios.isAxiosError(error) && error.response) {
                                        const toastId = toast.error(error.response.data.error || "Error desconocido", {
                                            autoClose: 10000
                                        });
                                        setTimeout(() => toast.dismiss(toastId), 20000);
                                    } else {
                                        const err = error as Error;
                                        toast.error(err.message || "Error desconocido");
                                    }
                            setNewUserAndPassword(false);
                            setShowWhatsappError(true);
                        } finally {
                            setLoading(false);
                        }

                    } else {
                        toast.error("No se pudo obtener el cliente. Por favor, verifica e intenta nuevamente.");
                        setShowWhatsappError(true);
                    }
                } catch (error) {
                    if (axios.isAxiosError(error) && error.response) {
                                        const toastId = toast.error(error.response.data.error || "Error desconocido", {
                                            autoClose: 10000
                                        });
                                        setTimeout(() => toast.dismiss(toastId), 20000);
                                    } else {
                                        const err = error as Error;
                                        toast.error(err.message || "Error desconocido");
                                    }
                    toast.error("No se pudo obtener el cliente. Por favor, verifica e intenta nuevamente.");
                    setShowWhatsappError(true);
                    setLoading(false);
                }










            } else if (identifierToFetch && "camara" in identifierToFetch) {
                console.log("Es un camara"); //CAMARA
                const camaraIdentifier = identifierToFetch.camara;

                //seteo el customerId y el customer identifier (identifier tipo E_)
                try {
                    const customerIdData = await getCustomerIdentifierByCamaraIdentifier(camaraIdentifier);
                    //OBTENGO EL CUSTOMER ID                    
                    if (customerIdData.customerId) {
                        try {
                            const customerData = await getCustomerByCustomerId(customerIdData.customerId);
                            console.log("customerData obtenido:", customerData);
                            //OBTENGO EL CLIENTE ENTERO
                            if (customerData && customerData.identifier) {


                                userData = {
                                    phoneNumber: phoneNumberComplete,
                                    identifier: customerData.identifier,
                                    email: sanitizedEmail,
                                    customerId: customerIdData.customerId,
                                    name,
                                    surname,
                                    password: passwordUrl,
                                    role: "guest"
                                };

                                try {
                                    const data = await handleUpdateOrCreateUser(userData);
                                    console.log("data", data);
                                    if (data && data.id) {
                                        setNewUserAndPassword(true);
                                        setURLuserValidated(data.user);
                                        toast.success("¡Datos validados!");
                                    } else {
                                        toast.error("No se pudieron validar tus datos. Por favor, verifica e intenta nuevamente.");
                                        setShowWhatsappError(true);
                                    }

                                } catch (error) {
                                    console.error(error);
                                    if (axios.isAxiosError(error) && error.response) {
                                        const toastId = toast.error(error.response.data.error || "Error desconocido", {
                                            autoClose: 10000
                                        });
                                        setTimeout(() => toast.dismiss(toastId), 20000);
                                    } else {
                                        const err = error as Error;
                                        toast.error(err.message || "Error desconocido");
                                    }
                                    toast.error("No se pudieron validar tus datos. Por favor, verifica e intenta nuevamente.");
                                    setNewUserAndPassword(false);
                                    setShowWhatsappError(true);
                                    setLoading(false);
                                } finally {
                                    setLoading(false);
                                }








                            } else {
                                toast.error("No se encontró un cliente asociado al cámara proporcionado.");
                                setLoading(false);
                                setShowWhatsappError(true);
                                return;
                            }
                        }
                        catch (error) {
                            if (axios.isAxiosError(error) && error.response) {
                                        const toastId = toast.error(error.response.data.error || "Error desconocido", {
                                            autoClose: 10000
                                        });
                                        setTimeout(() => toast.dismiss(toastId), 20000);
                                    } else {
                                        const err = error as Error;
                                        toast.error(err.message || "Error desconocido");
                                    }
                            toast.error("No se pudieron validar tus datos. Por favor, verifica e intenta nuevamente.");
                            setLoading(false);
                            setShowWhatsappError(true);
                            return;
                        }

                    } else {
                        toast.error("No se encontró un cliente asociado a la URL proporcionada.");
                        setLoading(false);
                        setShowWhatsappError(true);
                        return;
                    }
                } catch (error) {
                    if (axios.isAxiosError(error) && error.response) {
                                        const toastId = toast.error(error.response.data.error || "Error desconocido", {
                                            autoClose: 10000
                                        });
                                        setTimeout(() => toast.dismiss(toastId), 20000);
                                    } else {
                                        const err = error as Error;
                                        toast.error(err.message || "Error desconocido");
                                    }

                    toast.error("No se pudieron validar tus datos. Por favor, verifica e intenta nuevamente.");
                    setLoading(false);
                    setShowWhatsappError(true);
                    return;
                }










            } else {
                setLoading(false);
            }








        } else if (showUserAndPwdClick) {
            
            userData = {
                phoneNumber: phoneNumberPartial,
                email: sanitizedEmail
            };
            try {
                const data = await handleForgotPasswordWithEmailAndPhone(userData);
                if (data && data.state === "validated") {
                    setIsSuccess(true);
                    setUserValidated(data.userValidated);
                    toast.success("¡Datos validados!");
                } else {
                    toast.error("No se pudieron validar tus datos. Por favor, verifica e intenta nuevamente.");
                    setShowWhatsappError(true);
                }

            } catch (error) {
                console.error(error);
                if (axios.isAxiosError(error) && error.response) {
                    const toastId = toast.error(error.response.data.error || "Error desconocido", {
                        autoClose: 10000
                    });
                    setTimeout(() => toast.dismiss(toastId), 20000);
                } else {
                    const err = error as Error;
                    toast.error(err.message || "Error desconocido");
                }
                setIsSuccess(false);
                setShowWhatsappError(true);
            } finally {
                setLoading(false);
            }
            
        }



    };

    // Construye el mensaje de WhatsApp con el identifier codificado
    let whatsappMessage = "";
    let whatsappLink = "";
    if (identifier) {
        whatsappMessage = `Hola, necesito ayuda para recuperar mi contraseña. Mi credencial de empresa es "${identifier}"`;
        whatsappLink = `https://api.whatsapp.com/send?phone=15557546521&text=${encodeURIComponent(whatsappMessage)}`;
    } else {
        whatsappMessage = `Hola, necesito ayuda para recuperar mi contraseña. Ingrese la URL "${loginUrl}"`;
        whatsappLink = `https://api.whatsapp.com/send?phone=15557546521&text=${encodeURIComponent(whatsappMessage)}`;
    }


    if (!isOpen) {
        return null;
    }



    const updatePassword = async () => {
        setLoading(true);
        if (newPassword !== validatePassword) {
            toast.error("Las contraseñas no coinciden. Por favor, verifica e intenta nuevamente.");
            return;
        }

        console.log("userValidated en updatePassword:", userValidated);
        try {
            await updatePasswordFromLanding(userValidated?.id, newPassword!);
            toast.success("¡Contraseña actualizada exitosamente!");
            setUserWasValidated(true);
            //onClose();
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {
                                        const toastId = toast.error(error.response.data.error || "Error desconocido", {
                                            autoClose: 10000
                                        });
                                        setTimeout(() => toast.dismiss(toastId), 20000);
                                    } else {
                                        const err = error as Error;
                                        toast.error(err.message || "Error desconocido");
                                    }
            toast.error("Ocurrió un error al actualizar la contraseña. Por favor, intenta nuevamente.");
            console.error("Error al actualizar la contraseña:", error);
        }
        setLoading(false);
        setIsSuccess(false);
        //setNewPassword(null);
        //setValidatePassword(null);
        //setUserValidated(null);
        //setEmail("");
        setPhoneNumberPartial("");
        setIdentifier("");
    };



    const handleUrlClick = () => {
        setShowUrlClick(true);
    }

    return (
        <div
            className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
        >
            <div
className="relative bg-white rounded-lg shadow-2xl p-6 w-full max-w-xl max-h-[90vh] overflow-y-auto"            >
                <h2 className="text-2xl font-bold mb-4 text-center">Recuperar Contraseña</h2>

                {/*FIRST CONDICIONAL: SUCCESS*/}
                {isSuccess ? (

                    <div className="flex flex-col items-center justify-center text-center p-8">
                        <p className="text-xl font-semibold text-green-600 mb-4">
                            ¡Validación Exitosa! 🎉
                        </p>

                        <p className="text-xl font-semibold text-blue-600 mb-4 ">
                            Ingresa tu nueva contraseña:
                        </p>

                        <div className="flex items-center border rounded-lg overflow-hidden relative">
                            <Lock size={18} className="text-gray-400 ml-3" />
                            <input
                                className="w-full p-3 focus:outline-none"
                                type={showPassword ? "text" : "password"}
                                id="password"
                                name="password"
                                value={newPassword || ""}
                                onChange={(e) => setNewPassword(e.target.value)}
                                required
                            />
                            <button
                                className="absolute top-3 right-3 focus:outline-none"
                                type="button"
                                onClick={() => setShowPassword((prev) => !prev)}
                            >
                                {showPassword ? (
                                    <EyeOff size={18} className="text-gray-400" />
                                ) : (
                                    <Eye size={18} className="text-gray-400" />
                                )}
                            </button>
                        </div>

                        <p className="text-sm text-gray-600 mt-2 mb-2 text-left">
                            Verificala:
                        </p>

                        <div className="flex items-center border rounded-lg overflow-hidden relative">
                            <Lock size={18} className="text-gray-400 ml-3" />
                            <input
                                className="w-full p-3 focus:outline-none"
                                type={showValidatePassword ? "text" : "password"} // Tipo de input para validación
                                id="validatePassword"
                                name="validatePassword"
                                value={validatePassword || ''}
                                onChange={(e) => setValidatePassword(e.target.value)}
                                required
                            />
                            <button
                                className="absolute top-3 right-3 focus:outline-none"
                                type="button"
                                onClick={() => setShowValidatePassword((prev) => !prev)}
                            >
                                {showValidatePassword ? (
                                    <EyeOff size={18} className="text-gray-400" />
                                ) : (
                                    <Eye size={18} className="text-gray-400" />
                                )}
                            </button>
                        </div>

                        <p className="text-sm text-gray-600 mt-4">
                            Recordala para iniciar sesión.
                        </p>

                        <div className="flex flex-col gap-2 mt-6 w-full">


                            <button
                                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-150"
                                type="button"
                                onClick={updatePassword}
                                disabled={loading}
                            >
                                {loading ? (
                                    <div className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-white border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]" role="status">
                                        <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Cargando...</span>
                                    </div>
                                ) : "Actualizar contraseña"}
                            </button>


                        </div>
                    </div>

                ) : (


                    <>


                        {!userWasValidated && newUserAndPassword === false && !showIDClick && !showUrlClick && !showUserAndPwdClick && (
                            <div className="w-full max-w-md mx-auto mb-8">
                                {/* Mensaje Informativo (Tipo Alerta sutil) */}
                                <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-6 rounded-r-md">
                                    <p className="text-sm text-blue-700">
                                        <strong>Nota:</strong> Crearás una nueva contraseña una vez que validemos tus datos.
                                    </p>
                                    <p className="text-sm text-gray-600 mt-1">
                                        ¿Cómo solías ingresar anteriormente?
                                    </p>
                                </div>

                                {/* Contenedor de Opciones */}
                                <div className="flex flex-col gap-3">

                                    {/* Opción 1: ID */}
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowIDClick(true);
                                            setShowUrlClick(false);
                                            setShowUserAndPwdClick(false);
                                        }}
                                        className="group flex items-center justify-between w-full p-4 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-blue-50 hover:border-blue-400 transition-all duration-200 text-left"
                                    >
                                        <div>
                                            <p className="font-medium text-gray-700 group-hover:text-blue-700">
                                                Ingresaba con un <strong>ID</strong>
                                            </p>
                                            <p className="text-sm text-gray-500 mt-1">Si recuerdas tu número de identificación</p>
                                        </div>
                                        {/* Icono decorativo (flecha o símbolo) */}
                                        <span className="text-gray-400 group-hover:text-blue-500 text-xl">→</span>
                                    </button>

                                    {/* Opción 2: URL */}

                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowUrlClick(true);
                                            setShowIDClick(false);
                                            setShowUserAndPwdClick(false);
                                        }}
                                        className="group flex items-center justify-between w-full p-4 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-blue-50 hover:border-blue-400 transition-all duration-200 text-left"
                                    >
                                        <div>
                                            <p className="font-medium text-gray-700 group-hover:text-blue-700">
                                                Solo tengo la <strong>URL</strong> (link)
                                            </p>
                                            <p className="text-sm text-gray-500 mt-1">Si usabas una dirección web específica</p>
                                        </div>
                                        <span className="text-gray-400 group-hover:text-blue-500 text-xl">→</span>
                                    </button>

                                    {/* Opción 3: NUEVA (Mail y Contraseña) */}
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowUserAndPwdClick(true);
                                            setShowIDClick(false);
                                            setShowUrlClick(false);
                                        }}
                                        className="group flex items-center justify-between w-full p-4 bg-white border border-gray-200 rounded-lg shadow-sm hover:bg-blue-50 hover:border-blue-400 transition-all duration-200 text-left"
                                    >
                                        <div>
                                            <p className="font-medium text-gray-700 group-hover:text-blue-700">
                                                Ingresaba con <strong>Mail y Contraseña</strong>
                                            </p>
                                            <p className="text-sm text-gray-500 mt-1">Correo electrónico tradicional</p>
                                        </div>
                                        <span className="text-gray-400 group-hover:text-blue-500 text-xl">→</span>
                                    </button>

                                </div>
                            </div>
                        )}

                        <form onSubmit={handleSubmit} className="mt-6">
                            {/* El resto de tu formulario */}


{/*MAIL*/}
                            {(showIDClick || showUrlClick || showUserAndPwdClick) && !userWasValidated && newUserAndPassword == false ? (
                                <>
                                    
                                    {/* BOTÓN VOLVER */}
                                    <button
                                        type="button"
                                        onClick={handleBackToOptions}
                                        className="flex items-center text-sm text-gray-500 hover:text-blue-600 transition-colors mb-4"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                        </svg>
                                        Volver a opciones
                                    </button>
                                    <div className="mb-4">
                                        <label htmlFor="phoneNumberPartial" className="block text-gray-700 text-sm font-bold mb-2">
                                            Mail
                                        </label>

                                        <div className="flex items-center border rounded-lg overflow-hidden">
                                            <Mail size={18} className="text-gray-400 ml-3" />
                                            <input
                                                className="w-full p-3 focus:outline-none"
                                                type="email"
                                                id="email"
                                                name="email"
                                                value={email.toLowerCase().replace(/[^a-z0-9@.-]+/g, '').trim()}
                                                onChange={(e) => setEmail(e.target.value.toLowerCase().replace(/[^a-z0-9@.-]+/g, '').trim())}
                                                placeholder="ejemplo@lisual.com"
                                                required
                                            />
                                        </div>
                                    </div>
                                </>
                            ) : null}


{/*TELEFONO //MODIFICADO*/}
                            {(showUserAndPwdClick) && !userWasValidated && newUserAndPassword == false && (
                                <>
                                    
                                    <div className="mb-4">
                                        <label htmlFor="phoneNumberPartial" className="block text-gray-700 text-sm font-bold mb-2">
                                            Teléfono (Últimos 4 números)
                                        </label>
                                        <p className="text-xs text-gray-500 mb-4">
                                            Ej. si tu teléfono es +54 9 11 2244 1234, ingresá 1234
                                        </p>
                                        <div className="flex items-center border rounded-lg overflow-hidden">
                                            <Phone size={18} className="text-gray-400 ml-3" />
                                            <input
                                                className="w-full p-3 focus:outline-none"
                                                type="text"
                                                id="phoneNumberPartial"
                                                name="phoneNumberPartial"
                                                value={phoneNumberPartial.replace(/[^0-9]/g, '').trim().slice(0, 4)}
                                                onChange={(e) => setPhoneNumberPartial(e.target.value.replace(/[^0-9]/g, '').trim().slice(0, 4))}
                                                placeholder="1234"
                                                maxLength={4}
                                                required
                                            />
                                        </div>
                                    </div>
                                </>
                            )}

                            {showIDClick && !userWasValidated && newUserAndPassword == false && (
                                <>
                                    
                                    <div className="mb-4">
                                        <label htmlFor="customerIdentifier" className="block text-gray-700 text-sm font-bold mb-2">
                                            ID (Código que se utilizaba para ingresar)
                                        </label>
                                        <div className="flex items-center border rounded-lg overflow-hidden">
                                            <Lock size={18} className="text-gray-400 ml-3" />
                                            <input
                                                className="w-full p-3 focus:outline-none"
                                                type="text"
                                                id="customerIdentifier"
                                                name="customerIdentifier"
                                                value={identifier}
                                                onChange={(e) => setIdentifier(e.target.value)}
                                                placeholder="E_ejemplo1234"
                                                required
                                            />
                                        </div>
                                    </div>
                                </>

                            )}

                            {(showIDClick || showUrlClick) && newUserAndPassword == false && (
                                <div className="mb-4">
                                    <label htmlFor="phoneNumberComplete" className="block text-gray-700 text-sm font-bold mb-2">
                                        Teléfono (Código de pais, area y número, Ej. <strong>5491122441234</strong>)
                                    </label>
                                    <div className="flex items-center border rounded-lg overflow-hidden">
                                        <Phone size={18} className="text-gray-400 ml-3" />
                                        <input
                                            className="w-full p-3 focus:outline-none"
                                            type="text"
                                            id="phoneNumberComplete"
                                            name="phoneNumberComplete"
                                            value={phoneNumberComplete.replace(/[^0-9]/g, '').trim()}
                                            onChange={(e) => {
                                                const value = e.target.value.trim();
                                                // Limpiamos el valor de espacios, guiones y paréntesis, pero mantenemos un '+' inicial
                                                const cleanedValue = value.replace(/[\s\-\(\)]/g, '');

                                                // Aseguramos que solo haya un '+' al inicio, si existe.
                                                let finalValue = cleanedValue;
                                                if (cleanedValue.startsWith('+')) {
                                                    // Mantenemos el '+' inicial y luego removemos cualquier otro '+' del resto de la cadena.
                                                    finalValue = '+' + cleanedValue.substring(1).replace(/\+/g, '');
                                                } else {
                                                    // Si no empieza por '+', nos aseguramos de que no haya ninguno.
                                                    finalValue = cleanedValue.replace(/\+/g, '');
                                                }

                                                // Finalmente, solo permitimos dígitos después del posible '+' inicial.
                                                finalValue = finalValue.replace(/[^\d+]/g, ''); // Remueve todo lo que no sea dígito o '+'

                                                setPhoneNumberComplete(finalValue);
                                            }}
                                            placeholder="+5491122441234"
                                            required
                                        />
                                    </div>
                                </div>
                            )}

                            {showUrlClick && newUserAndPassword == false && (
                                <>
                                    <div className="mb-4">
                                        <label htmlFor="customerIdentifier" className="block text-gray-700 text-sm font-bold mb-2">
                                            URL de ingreso (Dirección web completa)
                                        </label>
                                        <div className="flex items-center border rounded-lg overflow-hidden">
                                            <Lock size={18} className="text-gray-400 ml-3" />
                                            <input
                                                className="w-full p-3 focus:outline-none"
                                                type="text"
                                                id="loginUrl"
                                                name="loginUrl"
                                                value={loginUrl}
                                                onChange={(e) => setLoginUrl(e.target.value)}
                                                placeholder="https://pro.lisual.com/customerDashboard/ejemplo"
                                                required
                                            />
                                        </div>
                                    </div>
                                </>
                            )}

                            {showUrlClick && newUserAndPassword == false && (
                                <>
                                    <div className="mb-4">
                                        <label htmlFor="customerIdentifier" className="block text-gray-700 text-sm font-bold mb-2">
                                            Tu nombre
                                        </label>
                                        <div className="flex items-center border rounded-lg overflow-hidden">
                                            <Lock size={18} className="text-gray-400 ml-3" />
                                            <input
                                                className="w-full p-3 focus:outline-none"
                                                type="text"
                                                id="name"
                                                name="name"
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                placeholder="Máximo"
                                                required
                                            />

                                        </div>
                                    </div>
                                </>
                            )}

                            {showUrlClick && newUserAndPassword == false && (
                                <>
                                    <div className="mb-4">
                                        <label htmlFor="customerIdentifier" className="block text-gray-700 text-sm font-bold mb-2">
                                            Apellido                                        </label>
                                        <div className="flex items-center border rounded-lg overflow-hidden">
                                            <Lock size={18} className="text-gray-400 ml-3" />
                                            <input
                                                className="w-full p-3 focus:outline-none"
                                                type="text"
                                                id="surname"
                                                name="surname"
                                                value={surname}
                                                onChange={(e) => setSurname(e.target.value)}
                                                placeholder="Meridio"
                                                required
                                            />
                                        </div>
                                    </div>
                                </>
                            )}


                            {showUrlClick && newUserAndPassword == false && (
                                <>
                                    <label htmlFor="passwordUrl" className="block text-gray-700 text-sm font-bold mb-2">
                                        Ingresá tu nueva contraseña:
                                    </label >
                                    <div className="flex items-center border rounded-lg overflow-hidden relative">
                                        <Lock size={18} className="text-gray-400 ml-3" />
                                        <input
                                            className="w-full p-3 focus:outline-none"
                                            type={showPassword ? "text" : "password"}
                                            id="passwordUrl"
                                            name="passwordUrl"
                                            value={passwordUrl || ""}
                                            placeholder='******'
                                            onChange={(e) => setPasswordUrl(e.target.value)}
                                            required
                                        />
                                        <button
                                            className="absolute top-3 right-3 focus:outline-none"
                                            type="button"
                                            onClick={() => setShowPassword((prev) => !prev)}
                                        >
                                            {showPassword ? (
                                                <EyeOff size={18} className="text-gray-400" />
                                            ) : (
                                                <Eye size={18} className="text-gray-400" />
                                            )}
                                        </button>
                                    </div>
                                </>
                            )}


                            {showUrlClick && newUserAndPassword == false && (
                                <>
                                    <label htmlFor="passwordUrl" className="block text-gray-700 text-sm font-bold mb-2">
                                        Verificá tu nueva contraseña:
                                    </label >
                                    <div className="flex items-center border rounded-lg overflow-hidden relative">
                                        <Lock size={18} className="text-gray-400 ml-3" />
                                        <input
                                            className="w-full p-3 focus:outline-none"
                                            type={showPassword ? "text" : "password"}
                                            id="passwordValidatorUrl"
                                            name="passwordValidatorUrl"
                                            value={passwordValidatorUrl || ""}
                                            placeholder='******'
                                            onChange={(e) => setPasswordValidatorUrl(e.target.value)}
                                            required

                                        />
                                        <button
                                            className="absolute top-3 right-3 focus:outline-none"
                                            type="button"
                                            onClick={() => setShowPassword((prev) => !prev)}
                                        >
                                            {showPassword ? (
                                                <EyeOff size={18} className="text-gray-400" />
                                            ) : (
                                                <Eye size={18} className="text-gray-400" />
                                            )}
                                        </button>
                                    </div>
                                </>
                            )}





                            {/* 3. Renderizado condicional del enlace de WhatsApp solo en caso de error */}
                            {showWhatsappError && (
                                <p className="text-sm text-red-600 mb-6 text-center mt-4 p-2 border border-red-200 bg-red-50 rounded-lg">
                                    ⚠️ No se pudo validar tu información.
                                    <a
                                        href={whatsappLink}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-green-600 hover:text-green-700 font-bold ml-1 flex items-center justify-center mt-2"
                                    >
                                        Contactanos por WhatsApp haciendo click aca
                                        <Phone size={16} className="ml-1" />
                                    </a>
                                    para recibir ayuda.
                                </p>
                            )}



                            {newUserAndPassword && (
                                <div className="flex flex-col items-center justify-center text-center p-8 bg-white rounded-xl shadow-2xl max-w-sm mx-auto">
                                    <p className="text-2xl font-bold text-indigo-600 mb-4 animate-bounce">
                                        ¡Validación Exitosa! 🎉
                                    </p>
                                    <p className="text-md text-gray-700 mb-6 text-center">
                                        Se ha creado un nuevo usuario y contraseña.
                                    </p>

                                    {/* Contenedor de Usuario */}
                                    <div className="w-full bg-indigo-50 border border-indigo-200 p-3 rounded-lg mb-4 shadow-inner">
                                        <p className="text-sm font-medium text-indigo-800">
                                            Tu usuario es:
                                        </p>
                                        {/* Asumiendo que tu variable para el usuario es email */}
                                        <p className="text-xl font-bold text-indigo-900 mt-1 break-all">
                                            {email}
                                        </p>
                                    </div>

                                    {/* Contenedor de Contraseña */}
                                    <div className="w-full bg-yellow-50 border border-yellow-200 p-3 rounded-lg shadow-inner mb-4">
                                        <p className="text-sm font-medium text-yellow-800 mb-1">
                                            Tu contraseña es:
                                        </p>
                                        <div className="flex items-center justify-center">
                                            <span className="text-xl font-bold text-yellow-900 break-all">
                                                {/* Oculta o muestra la contraseña según el estado 'showPassword' */}
                                                {showPasswordGenerated ? passwordUrl : '****************'}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Contenedor de Botones (Ahora debajo del campo) */}
                                    <div className="flex justify-center space-x-3 w-full mb-6">

                                        {/* Botón de Ver/Ocultar */}
                                        <button
                                            type="button"
                                            onClick={handleTogglePassword}
                                            className="flex items-center px-4 py-2 text-sm font-medium rounded-lg text-indigo-700 bg-indigo-100 hover:bg-indigo-200 transition-colors duration-200"
                                            aria-label={showPasswordGenerated ? "Ocultar contraseña" : "Mostrar contraseña"}
                                        >
                                            {showPasswordGenerated ? (
                                                <>
                                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.057 10.057 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.975 9.975 0 011.563-2.053m3.86-1.896c1.074-.757 2.45-1.161 3.844-1.161h.001c4.478 0 8.268 2.943 9.543 7a9.975 9.975 0 01-1.563 2.053m-3.86-1.896A2 2 0 0012 9a2 2 0 00-2 2"></path></svg>
                                                    Ocultar
                                                </>
                                            ) : (
                                                <>
                                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg>
                                                    Mostrar
                                                </>
                                            )}
                                        </button>

                                        {/* Botón de Copiar */}
                                        <button
                                            type="button"
                                            onClick={handleCopy}
                                            className={`flex items-center px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200
                    ${copyStatus === 'copied'
                                                    ? 'bg-green-500 hover:bg-green-600 text-white'
                                                    : 'bg-indigo-500 hover:bg-indigo-600 text-white'
                                                }`}
                                            aria-label={copyStatus === 'copied' ? "Contraseña copiada" : "Copiar contraseña"}
                                        >
                                            {copyStatus === 'copied' ? (
                                                <>
                                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                                                    Copiado
                                                </>
                                            ) : (
                                                <>
                                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-2"></path></svg>
                                                    Copiar
                                                </>
                                            )}
                                        </button>
                                    </div>

                                    <p className="text-sm text-gray-500 italic">
                                        Por favor, recordá tu nueva contraseña para iniciar sesión.
                                    </p>
                                </div>
                            )}



                            {userWasValidated && (
                                <div className="flex flex-col items-center justify-center text-center p-8 bg-white rounded-xl shadow-2xl max-w-sm mx-auto">
                                    <p className="text-2xl font-bold text-indigo-600 mb-4 animate-bounce">
                                        ¡Validación Exitosa! 🎉
                                    </p>
                                    <p className="text-md text-gray-700 mb-6 text-center">
                                        Se ha creado un nuevo usuario y contraseña.
                                    </p>

                                    {/* Contenedor de Usuario */}
                                    <div className="w-full bg-indigo-50 border border-indigo-200 p-3 rounded-lg mb-4 shadow-inner">
                                        <p className="text-sm font-medium text-indigo-800">
                                            Tu usuario es:
                                        </p>
                                        {/* Asumiendo que tu variable para el usuario es email */}
                                        <p className="text-xl font-bold text-indigo-900 mt-1 break-all">
                                            {email}
                                        </p>
                                    </div>

                                    {/* Contenedor de Contraseña */}
                                    <div className="w-full bg-yellow-50 border border-yellow-200 p-3 rounded-lg shadow-inner mb-4">
                                        <p className="text-sm font-medium text-yellow-800 mb-1">
                                            Tu contraseña es:
                                        </p>
                                        <div className="flex items-center justify-center">
                                            <span className="text-xl font-bold text-yellow-900 break-all">
                                                {/* Oculta o muestra la contraseña según el estado 'showPassword' */}
                                                {showPasswordGenerated ? newPassword : '****************'}
                                            </span>
                                        </div>
                                    </div>

                                    {/* Contenedor de Botones (Ahora debajo del campo) */}
                                    <div className="flex justify-center space-x-3 w-full mb-6">

                                        {/* Botón de Ver/Ocultar */}
                                        <button
                                            type="button"
                                            onClick={handleTogglePassword}
                                            className="flex items-center px-4 py-2 text-sm font-medium rounded-lg text-indigo-700 bg-indigo-100 hover:bg-indigo-200 transition-colors duration-200"
                                            aria-label={showPasswordGenerated ? "Ocultar contraseña" : "Mostrar contraseña"}
                                        >
                                            {showPasswordGenerated ? (
                                                <>
                                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13.875 18.825A10.057 10.057 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.975 9.975 0 011.563-2.053m3.86-1.896c1.074-.757 2.45-1.161 3.844-1.161h.001c4.478 0 8.268 2.943 9.543 7a9.975 9.975 0 01-1.563 2.053m-3.86-1.896A2 2 0 0012 9a2 2 0 00-2 2"></path></svg>
                                                    Ocultar
                                                </>
                                            ) : (
                                                <>
                                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg>
                                                    Mostrar
                                                </>
                                            )}
                                        </button>

                                        {/* Botón de Copiar */}
                                        <button
                                            type="button"
                                            onClick={handleCopyNewPassword}
                                            className={`flex items-center px-4 py-2 text-sm font-medium rounded-lg transition-colors duration-200
                                            ${copyStatus === 'copied'
                                                    ? 'bg-green-500 hover:bg-green-600 text-white'
                                                    : 'bg-indigo-500 hover:bg-indigo-600 text-white'
                                                }`}
                                            aria-label={copyStatus === 'copied' ? "Contraseña copiada" : "Copiar contraseña"}
                                        >
                                            {copyStatus === 'copied' ? (
                                                <>
                                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path></svg>
                                                    Copiado
                                                </>
                                            ) : (
                                                <>
                                                    <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-2"></path></svg>
                                                    Copiar
                                                </>
                                            )}
                                        </button>
                                    </div>

                                    <p className="text-sm text-gray-500 italic">
                                        Por favor, recordá tu nueva contraseña para iniciar sesión.
                                    </p>
                                </div>
                            )}


                            <div className="flex flex-col gap-2 mt-6">
                                {(showIDClick || showUrlClick || showUserAndPwdClick) && !userWasValidated && newUserAndPassword == false ? (
                                    <button
                                        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-150"
                                        type="submit"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <div className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-solid border-white border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]" role="status">
                                                <span className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]">Cargando...</span>
                                            </div>
                                        ) : "Validar Datos"}
                                    </button>
                                ) : null}

                                



                                <button
                                    className="w-full bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-3 px-4 rounded-lg focus:outline-none focus:shadow-outline transition duration-150"
                                    type="button"
                                    onClick={() => {
                                        onClose();
                                        setShowIDClick(false);
                                        setShowUrlClick(false);
                                        setShowUserAndPwdClick(false);
                                        setShowWhatsappError(false);
                                        setPhoneNumberPartial("");
                                        setIdentifier("");
                                        setLoginUrl("");
                                        setEmail("");
                                        setName("");
                                        setSurname("");
                                        setPhoneNumberComplete("");
                                        setPhoneNumberPartial("");
                                        setPasswordUrl("");
                                        setPasswordValidatorUrl("");
                                        setNewUserAndPassword(false);
                                        setShowIDClick(false);
                                        setUserWasValidated(false);
                                        setNewPassword(null);
                                        setValidatePassword(null);
                                        setUserValidated(null);
                                    }}
                                    disabled={loading}
                                >
                                    {(newUserAndPassword == false && userWasValidated == false) ? "Cancelar" : "Cerrar"}
                                </button>
                            </div>
                        </form>
                    </>
                )}

            </div>
        </div>
    );
};

export default ForgotPwdModal;